/*
 * @Author: YuanYuan
 * @Date: 2023-08-24 18:45:42
 * @LastEditTime: 2025-04-29 09:46:25
 * @description:
 * meta.title: 面包屑显示内容
 * meta.backable: 是否有返回按钮
 * meta.leftMenuCode: 对应左侧菜单key
 * meta.leftActiveIndex: 对应左侧菜单选中的index（主页面可不写默认为path值，内部页面手动指向）
 * meta.noScrollbar: 页面不增加滚动条，内容区自行处理滚动条
 */
const routes = []
const context = require.context('./', true, /^\.\/(?!index).*?\.js$/)

context.keys().forEach(key => {
  routes.push(...context(key).default)
})

export default routes
